import { Component, OnInit } from "@angular/core";
import { NgClass } from "@angular/common";
import { MatDialogContent, MatDialogClose, MatDialogTitle } from "@angular/material/dialog";

@Component({
  selector: "app-modal-precios",
  templateUrl: "./modal-precios.component.html",
  styleUrls: ["./modal-precios.component.scss"],
  imports: [MatDialogContent, MatDialogClose, MatDialogTitle, NgClass],
})
export class ModalPreciosComponent implements OnInit {
  mesActive: boolean;
  semActive: boolean;
  yearActive: boolean;

  constructor() {}

  ngOnInit(): void {
    this.mesActive = true;
  }

  clickMes(): void {
    this.mesActive = true;
    this.semActive = false;
    this.yearActive = false;
  }

  clickSemestre(): void {
    this.semActive = true;
    this.mesActive = false;
    this.yearActive = false;
  }

  clickAnyo(): void {
    this.yearActive = true;
    this.semActive = false;
    this.mesActive = false;
  }
}
